module.exports = __webpack_public_path__ + "static/mobile@2x-1024x847-417577a0ebbfccb93c2bddd551dd70d1.png";